import * as yup from 'yup'
import 'yup-phone'

export default yup.object().shape({
  firstName: yup.string().required().label('First name'),
  lastName: yup.string().required().label('Last name'),
  contact: yup.object().shape({
    mobileNumber: yup.string().required().phone().label('Mobile number'),
    officeNumber: yup
      .string()
      .notRequired()
      .nullable()
      .test('is-valid-office-number', 'Office number is not valid', (value) => {
        if (!value) return true // if the value is null or undefined, it's valid
        if (value.length <= 6) return true // if the value is 5 or fewer characters, it's valid
        return yup.string().phone().isValidSync(value)
      })
      .label('Office number'),
  }),
})
